import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Main = styled.section`
   display: flex;
   flex-direction: column;
   position: relative;
   width: 100%;
   height: 100vh;
   background:
      radial-gradient(ellipse 70% 50% at 10% -10%, rgba(227, 222, 251, 0.95), transparent 55%),
      radial-gradient(ellipse 60% 45% at 100% 10%, rgba(219, 250, 245, 0.7), transparent 50%),
      ${theme.colors.background};
   transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
   
   .contactUs {
      position: fixed;
      background: #d22d2d;
      color: #fff;
      opacity: 0;
      border-radius: 5px 0 0 5px;
      padding: 2px 15px;
      font-size: 15px;

      &.show {
         transition: all .3s ease-in-out;
         opacity: 1;
         bottom: 15px;
         right: 0;
         z-index: 999;
         box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
      }
      span:hover {
         text-decoration: underline;
         cursor: pointer;
      }
   }
   .chat-toggle-icon {
      position: fixed;
      bottom: 20px;
      right: 20px;
      height: 50px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 13px;
      cursor: pointer;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      z-index: 1000;
      padding: 0 30px;
      gap: 8px;
      
      svg {
         font-size: 18px;
      }
      span {
         margin-top: 3px;
         font-weight: 500;
         white-space: nowrap;
      }
      &:hover {
         transform: scale(1.05);
         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
         background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
      }
      &:active {
         transform: scale(0.95);
      }
   }
			.sc-fYDAzb.jMKPNE.react-flow__panel{
				left: -5px !important;
				bottom: -3px !important;
			}

			.logs > div.direct,
			.logs > div .direct,
			.logs > div .log {
			background : white ;
				border-radius : 12px ;
				overflow : hidden ;
				box-shadow : 0 20px 25px -5px rgba(0, 0, 0, 0.06),0 8px 10px -6px rgba(0, 0, 0, 0.06) ;
			}

   /* One bottom row: zoom stack | status chips …… AI FAB (same baseline) */
   .bottomDock {
      position: absolute;
      left: calc(var(--wf-sidebar-end, 118px) + 14px);
      right: 196px;
      bottom: 22px;
      z-index: 5;
      display: flex;
      align-items: flex-end;
      gap: 12px;
      pointer-events: none;
      transition: left 0.32s cubic-bezier(0.2, 0.9, 0.25, 1);

      > * {
         pointer-events: auto;
      }

      .logs > * {
         flex-shrink: 0;
      }
   }

   .logs {
      position: relative !important;
      left: auto !important;
      right: auto !important;
      bottom: auto !important;
      display: flex;
      flex: 1 1 auto;
      gap: 10px;
      flex-wrap: wrap;
      align-items: flex-end;
      z-index: 4;
      max-width: none;
      min-width: 0;
      transition: none;

      i.ti {
         display: inline-flex;
         font-size: 16px;
         line-height: 1;
      }
      .boxLog {
         position: relative;
         display: flex;
         align-items: center;
         gap: 11px;
         border-radius: 15px;
         background-color: ${ theme.surface.groupBg };
         border: 1px solid ${ theme.surface.groupBorder };
         padding: 10px 15px 10px 10px;
         height: 52px;
         min-height: 52px;
         box-sizing: border-box;
         white-space: nowrap;
         z-index: 98;
         font-size: 13px;
         cursor: pointer;
         box-shadow: ${ theme.shadows.float };
         transition: transform 0.18s ease, box-shadow 0.18s ease;
         flex-shrink: 0;

         &:hover {
            background-color: ${ theme.surface.groupBg };
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(29, 20, 70, 0.06), 0 16px 28px -10px rgba(29, 20, 70, 0.2);
         }

         .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 34px;
            height: 34px;
            flex-shrink: 0;
            background: linear-gradient(150deg, #FFE1B0, #FFC876);
            color: #8A5A16;
            margin-right: 0;
            border-radius: 10px;
            box-shadow: 0 1px 0 rgba(255, 255, 255, 0.6) inset, 0 6px 12px -6px rgba(29, 20, 70, 0.2);
         }
         .info {
            display: flex;
            flex-direction: column;
            gap: 2px;

            > span {
               font-size: 13px;
               font-weight: 700;
               color: ${ theme.colors.text };
            }
            > div {
               display: flex;
               align-items: center;
               gap: 10px;
               font-size: 11px;
               font-weight: 600;
               color: ${ theme.surface.mutedText };
               margin-top: 0;

               span:first-of-type {
                  margin-right: 0;
               }
            }
         }
         &.processReport {
            .icon {
               background: linear-gradient(150deg, #CFE0FF, #A9C5FF);
               color: #2C4FA8;
            }
            .info > div span svg {
               margin-right: 4px;
            }
         }
         &.liveLog {
            .icon {
               background: linear-gradient(150deg, #FFD3C9, #FFAD9C);
               color: #B23A22;
            }
         }
         &.monitorLog {
            .icon {
               background: linear-gradient(150deg, #FFD3B0, #FFAE72);
               color: #B2560F;
            }
         }
      }
   }
   .templateConfirmOverlay {
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(15, 23, 42, 0.42);
      backdrop-filter: blur(4px);
      z-index: 1200;
      padding: 20px;
   }
   .templateConfirmModal {
      width: min(420px, 100%);
      border-radius: 8px;
      background: #fff;
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.24);
      padding: 22px;
      color: #0f172a;

      h3 {
         margin: 0 0 10px;
         font-size: 20px;
         line-height: 1.2;
      }
      p {
         margin: 0;
         color: #475569;
         font-size: 14px;
         line-height: 1.55;
      }
      strong {
         color: #0f172a;
      }
   }
   .templateConfirmActions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 22px;

      button {
         border: 1px solid #cbd5e1;
         border-radius: 7px;
         background: #fff;
         color: #334155;
         padding: 10px 14px;
         font-size: 14px;
         font-weight: 600;
         cursor: pointer;
         transition: all .2s ease-in-out;

         &:hover:not(:disabled) {
            background: #f8fafc;
         }
         &:disabled {
            cursor: not-allowed;
            opacity: 0.7;
         }
         &.primary {
            border-color: #22c55e;
            background: #22c55e;
            color: #fff;

            &:hover:not(:disabled) {
               background: #16a34a;
            }
         }
      }
   }
   .react-flow {
      position: relative;
      display: flex;
      justify-content: center;
      
      .react-flow__minimap {
         box-shadow: 0 0 6px rgba(0,0,0,0.1), 0 0 6px rgba(0,0,0,0.1);
      }
      .react-flow__handle {
         width: 12px;
         height: 12px;
         background-color: #fff;
         border: 2.5px solid #9C97B3;
         box-shadow: 0 2px 6px rgba(29, 20, 70, 0.15);
         transition: all .2s ease-in-out;

         &:hover {
            width: 14px;
            height: 14px;
            border-color: #8172FF;
            background-color: #fff;
         }
         &.hide {
            opacity: 0;
         }
         &.react-flow__handle-top {
            top: calc(-16px / 2);
         }
         &.react-flow__handle-bottom {
            bottom: calc(-16px / 2);
         }
         &.react-flow__handle-left {
            left: calc(-20px / 2);
         }
         &.react-flow__handle-right {
            right: calc(-20px / 2);
         }
         &.react-flow__handle-top .handleTitle {
            top: -25px;
         }
         &.react-flow__handle-bottom .handleTitle {
            bottom: -25px;
         }
         &.react-flow__handle-left .handleTitle {
            top: 5px;
            right: calc(100% + 5px);
         }
         &.react-flow__handle-right .handleTitle {
            top: 5px;
            left: calc(100% + 5px);
         }
         .handleTitle {
            position: absolute;
            font-family: 'IBM Plex Mono', ui-monospace, monospace;
            font-size: 9.5px;
            font-weight: 500;
            white-space: nowrap;
            color: ${theme.colors.textSecondary};
            background-color: #fff;
            border: 1px solid ${theme.colors.border};
            box-shadow: 0 2px 6px rgba(29, 20, 70, 0.1);
            padding: 2px 6px;
            border-radius: 6px;
            z-index: -1;
         }
         &.handle-clickup {
            &.handle-child-Output-Lists {
               top: 20%;
            }
            &.handle-child-Full-Output {
               top: 40%;
            }
            &.handle-child-Output-Tasks {
               top: 60%;
            }
            &.handle-child-Output-Task-Link {
               top: 80%;
            }
            &.handle-child-Entity-Name {
               top: 25%;
            }
            &.handle-child-Headers {
               top: 52%;
            }
            &.handle-child-File {
               top: 80%;
            }
         }
         &.handle-routing {
            &.handle-child-Output-True {
               top: 35%;
            }
            &.handle-child-Output-False {
               top: 70%;
            }
         }
         &.handle-ocr {
            &.handle-child-Output-Full {
               top: 35%;
            }
            &.handle-child-Output-Processed-Files {
               top: 70%;
            }
         }
         &.handle-aiAgent {
            &.handle-child-Input {
               top: 50%;
            }
            &.handle-child-Tools {
               top: 72%;
            }
            &.handle-child-Output {
               top: 35%;
            }
         }
         &.handle-messengerSendMessage {
            &.handle-child-Listener {
               top: 35%;
            }
            &.handle-child-Ai-Content {
               top: 50%;
            }
         }
             &.handle-instaSendMessage {
            &.handle-child-Listener {
               top: 35%;
            }
            &.handle-child-Ai-Content {
               top: 50%;
            }
         }
         &.handle-odoo {
            &.handle-child-Name {
               top: 13%;
            }
            &.handle-child-Expected_Revenue {
               top: 23%;
            }
            &.handle-child-Probability {
               top: 33%;
            }
            &.handle-child-Customer {
               top: 43%;
            }
            &.handle-child-Email {
               top: 53%;
            }
            &.handle-child-Phone {
               top: 63%;
            }
            &.handle-child-Salesperson {
               top: 73%;
            }
            &.handle-child-Expected_Closing {
               top: 83%;
            }
            &.handle-child-Company_Name {
               top: 93%;
            }
            &.handle-child-Address {
               top: 17%;
            }
            &.handle-child-Contact_Name {
               top: 27%;
            }
            &.handle-child-Job_Position {
               top: 37%;
            }
            &.handle-child-Mobile {
               top: 47%;
            }
            &.handle-child-Website {
               top: 57%;
            }
            &.handle-child-Campaign {
               top: 67%;
            }
            &.handle-child-Medium {
               top: 77%;
            }
            &.handle-child-Sales_Team {
               top: 87%;
            }
         }
         &.handle-facebook {
            &.handle-child-Page-Id {
               top: 35%;
            }
            &.handle-child-Content {
               top: 70%;
            }
         }
         &.handle-leadsScorer {
            &.handle-child-Row-Data {
               top: 35%;
            }
            &.handle-child-Criteria {
               top: 70%;
            }
         }
         &.handle-realEstate {
            &.handle-child-Property {
               top: 25%;
            }
            &.handle-child-Location {
               top: 45%;
            }
            &.handle-child-City {
               top: 65%;
            }
            &.handle-child-Size {
               top: 85%;
            }
         }
         &.handle-openai {
            &.handle-child-Instructions {
               top: 35%;
            }
            &.handle-child-Input {
               top: 60%;
            }
         }
         &.handle-deepseek {
            &.handle-child-Instructions {
               top: 35%;
            }
            &.handle-child-Input {
               top: 60%;
            }
         }
         &.handle-qwen {
            &.handle-child-Instructions {
               top: 35%;
            }
            &.handle-child-Input {
               top: 60%;
            }
         }
         &.handle-docSearch {
            &.handle-child-Input {
               top: 35% !important;
            }
            &.handle-child-File {
               top: 70%;
            }
         }
         &.handle-urlSearch {
            &.handle-child-Input {
               top: 25%;
            }
            &.handle-Website-URL {
               top: 50%;
            }
            &.handle-child-File {
               top: 75%;
            }
         }
         &.handle-googleGemini {
            &.handle-child-Input {
               top: 35%;
            }
            &.handle-child-File {
               top: 60%;
            }
         }
         &.handle-webhook {
            &.handle-child-Full-Output {
               top: 12.857%;
            }
            &.handle-child-Extractor-1 {
               top: 29.714%;
            }
            &.handle-child-Extractor-2 {
               top: 46.571%;
            }
            &.handle-child-Extractor-3 {
               top: 64.428%;
            }
            &.handle-child-Extractor-4 {
               top: 82.285%;
            }
            &.handle-child-Extractor-5 {
               top: 79.142%;
            }
            /*&.handle-child-Extractor-7 {
               top: 89.999%;
            } */
         }
         &.handle-sequencer {
            &.handle-child-RAG-Connection {
               top: 25%;
            }
            &.handle-child-ChatId {
               top: 50%;
            }
            &.handle-child-Input {
               top: 75%;
            }
            &.handle-child-Output-Message {
               left: 15%;
            }
            &.handle-child-Output-Full {
               left: 45%;
            }
            &.handle-child-Output-Summary {
               left: 75%;
            }
         }
         &.handle-spreadsheet {
            &.handle-child-Input {
               top: 35%;
            }
            &.handle-child-Spreadsheet-Id {
               top: 70%;
            }
            
         }
         &.handle-chatAgent {
            &.handle-child-Knowledge-Bases {
               top: 25%;
            }
            &.handle-child-ChatId {
               top: 50%;
            }
            &.handle-child-Message {
               top: 75%;
            }
            /* &.handle-child-Output-Profile {
               left: 30%;
            }
            &.handle-child-Output {
               left: 65%;
            } */
         }
         &.handle-chatAgent {
            &.handle-child-Output {
               top: 35%;
            }
            &.handle-child-Output-Message {
               top: 65%;
            }
         }
      }
   }
`;
